import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./screens/Landing";
import Article from "./articles/ArticlesPage";
import Main2023 from "./articles/2023/2023Main";
import Subscription from "./screens/Subscription";
import Guidelines from "./screens/Guidelines";
import Editorial from "./screens/Editorial";
import Contact from "./screens/Contact";
import About from "./screens/About";
import Main2018 from "./articles/2018/2018Main";
import Main2019 from "./articles/2019/2019Main";
import Main2019V2 from "./articles/2019/2019MainV2";
import Main2020 from "./articles/2020/Main2020";
import Main2021 from "./articles/2021/Main2021";
import Main2022 from "./articles/2022/Main2022";
import Main2025 from "./articles/2025/2025Main";
import Issue22025 from "./articles/2025/2025issue2";
import Issue12026 from "./articles/2026/2026Issue1";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Landing />} />
        <Route exact path="/article" element={<Article />} />
        <Route exact path="/2023" element={<Main2023 />} />
        <Route exact path="/subscription" element={<Subscription />} />
        <Route exact path="/guide" element={<Guidelines />} />
        <Route exact path="/editorial" element={<Editorial />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/2018" element={<Main2018 />} />
        <Route exact path="/2019" element={<Main2019 />} />
        <Route exact path="/2019v2" element={<Main2019V2 />} />
        <Route exact path="/2020" element={<Main2020 />} />
        <Route exact path="/2021" element={<Main2021 />} />
        <Route exact path="/2022" element={<Main2022 />} />
        <Route exact path="/2025" element={<Main2025 />} />
        <Route exact path="/2025i2" element={<Issue22025 />} />
        <Route exact path="/2026i1" element={<Issue12026 />} />
      </Routes>
    </Router>
  );
}
